import { makeStyles } from "@fluentui/react-components";

export const useStyles = makeStyles({
  root: {
    minHeight: "100vh",
    padding: "20px",
  },
  header: {
    textAlign: "center",
    marginBottom: "24px",
  },
});

export default useStyles;
